import { useEffect } from 'react';

// Extend window type for missing translation reporter
declare global {
  interface Window {
    __missingTranslationsQueue?: string[];
    __reportMissingTranslation?: (key: string) => void;
  }
}

export function SetupMissingTranslationReporter() {
  useEffect(() => {
    // Only include in development
    if (!import.meta.env.DEV) {
      return;
    }

    // Set up a temporary reporter that stores missing translations
    if (typeof window !== 'undefined') {
      window.__missingTranslationsQueue = [];
      window.__reportMissingTranslation = function (key: string) {
        window.__missingTranslationsQueue?.push(key);
      };
    }
  }, []);

  // Only render in development
  if (!import.meta.env.DEV) {
    return null;
  }

  return null;
}
